/* ============================================================
   VERA SANTORI - Buscador desplegable
   ------------------------------------------------------------
   La lupa no lleva a otra pagina: abre un panel debajo de la
   cabecera y los resultados van apareciendo mientras se escribe.

   Los resultados los pinta Liquid (sections/predictive-search),
   que se pide con /search/suggest?...&section_id=... y se inserta
   tal cual. Asi los precios salen con el filtro money y no hay que
   reformatearlos aqui a mano.

   Si el JavaScript no carga, la lupa sigue siendo un enlace normal
   a la pagina de busqueda, y esa pagina filtra por su cuenta en
   Liquid: nadie se queda sin buscar ni ve resultados de relleno.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Donde debe buscar Shopify. Sin esto busca tambien dentro de
     las descripciones, y un vestido cuya descripcion dice
     "combinalo con pantalones" salia al buscar pantalones. */
  var FIELDS = 'title,product_type,tag,variants.title';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 260;

  /* ------------------------------------------------------------
     Exigir TODAS las palabras

     Shopify, con dos palabras, devuelve lo que contenga una U OTRA.
     Buscar "pantalones rojos" sacaba vestidos rojos y pantalones
     grises. Uniendolas con AND se piden las dos a la vez.

     No se toca la busqueda si ya trae comillas u operadores.
     ------------------------------------------------------------ */

  function allWords(term) {
    if (term.indexOf('"') > -1) { return term; }

    var parts = term.split(' ').filter(function (word) { return word.length > 0; });
    if (parts.length < 2) { return term; }

    for (var i = 0; i < parts.length; i++) {
      var upper = parts[i].toUpperCase();
      if (upper === 'AND' || upper === 'OR' || upper === 'NOT') { return term; }
    }

    return parts.join(' AND ');
  }

  /* ------------------------------------------------------------
     Normalizar la pagina de resultados

     A /search se llega por muchos caminos que no pasan por el
     panel. Aqui se corrige la direccion una sola vez; vs=1 marca
     que ya esta hecha y evita el bucle.

     Ojo: dentro del editor de temas de Shopify esta redireccion
     NO se ejecuta, porque el editor controla la navegacion de su
     vista previa. Por eso la pagina de resultados filtra ademas
     por su cuenta en Liquid, que es la capa que nunca falla.
     ------------------------------------------------------------ */

  function normaliseResultsPage() {
    if (location.pathname.indexOf('/search') === -1) { return; }
    if (!window.URLSearchParams) { return; }

    var params = new URLSearchParams(location.search);
    var raw = params.get('q');
    if (!raw) { return; }
    if (params.get('vs') === '1') { return; }

    var term = raw.trim();
    var strict = allWords(term);

    params.set('q', strict);
    params.set('type', 'product');
    params.set('options[fields]', FIELDS);
    params.set('options[prefix]', 'last');
    params.set('vs', '1');

    try {
      location.replace(location.pathname + '?' + params.toString());
    } catch (e) {
      /* Entornos que bloquean la navegacion, como el editor. */
    }
  }

  normaliseResultsPage();

  /* ---------------- Panel de la cabecera ---------------- */

  var toggle = document.querySelector('[data-search-toggle]');
  var panel = document.querySelector('[data-search-panel]');
  var backdrop = document.querySelector('[data-search-backdrop]');
  var input = document.querySelector('[data-search-input]');
  var results = document.querySelector('[data-search-results]');
  var closeBtn = document.querySelector('[data-search-close]');
  var form = document.querySelector('[data-search-form]');

  if (!toggle || !panel || !input || !results) { return; }

  var timer = null;
  var controller = null;
  var lastTerm = '';

  function resultsUrl(term) {
    return ROOT + 'search'
      + '?q=' + encodeURIComponent(allWords(term))
      + '&type=product'
      + '&options%5Bfields%5D=' + encodeURIComponent(FIELDS)
      + '&options%5Bprefix%5D=last'
      + '&vs=1';
  }

  function open() {
    panel.hidden = false;
    if (backdrop) { backdrop.hidden = false; }
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('vs-search-open');
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
  }

  function close() {
    panel.hidden = true;
    if (backdrop) { backdrop.hidden = true; }
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('vs-search-open');
    if (timer) { clearTimeout(timer); timer = null; }
    if (controller) { controller.abort(); controller = null; }
  }

  function isOpen() {
    return !panel.hidden;
  }

  function setState(name) {
    results.setAttribute('data-state', name);
  }

  function search(term) {
    if (controller) { controller.abort(); }

    var url = ROOT + 'search/suggest'
      + '?q=' + encodeURIComponent(allWords(term))
      + '&resources[type]=product,collection,query'
      + '&resources[limit]=6'
      + '&resources[options][fields]=' + encodeURIComponent(FIELDS)
      + '&section_id=predictive-search';

    var options = {};
    if (window.AbortController) {
      controller = new AbortController();
      options.signal = controller.signal;
    }

    setState('loading');

    fetch(url, options)
      .then(function (response) {
        if (!response.ok) { throw new Error('respuesta ' + response.status); }
        return response.text();
      })
      .then(function (html) {
        if (term !== lastTerm) { return; }
        results.innerHTML = html;
        setState('ready');
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') { return; }
        if (term !== lastTerm) { return; }
        results.innerHTML = '';
        setState('error');
      });
  }

  function onType() {
    var term = input.value.trim();
    lastTerm = term;

    if (timer) { clearTimeout(timer); }

    if (term.length < MIN_CHARS) {
      if (controller) { controller.abort(); controller = null; }
      results.innerHTML = '';
      setState('idle');
      return;
    }

    timer = setTimeout(function () { search(term); }, DEBOUNCE_MS);
  }

  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    if (isOpen()) { close(); } else { open(); }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (event) {
      event.preventDefault();
      close();
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', close);
  }

  input.addEventListener('input', onType);

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var term = input.value.trim();
      if (!term) { return; }
      window.location.href = resultsUrl(term);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) {
      close();
      toggle.focus();
    }
  });

  results.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('a')) { close(); }
  });
})();
